import { combineReducers } from 'redux'
import stack from './stack'
import ui from './ui'

export default combineReducers({
	stack,
	ui
})